<div id="operations_list">    
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>        
    }
    @else {    
        @if(this.operationsItemsDisplayed.length > 0){
            @for(operationItem of this.operationsItemsDisplayed; track operationItem.id){
                <app-operation-item [operation]="operationItem" [displayRemainingDays]="this.displayRemainingDays" [displayQuota]="this.displayQuota" [displayBtnAddIntervention]="this.displayBtnAddIntervention" [disabledBtnAddIntervention]="this.disabledBtnAddIntervention || operationItem.isPlanningClosed" (onSelectOperation)="this.selectOperation($event)" (onAddIntervention)="this.addIntervention($event)"></app-operation-item>
            }
        } 
        @else{
            <marv-message type="info">{{'MSG_NO_MY_OPERATION' | translate}}</marv-message>
        }
    }
</div>